<template>
  <section class="lg:container lg:mx-auto px-5">
    <div class="pb-6 bg-white xl:rounded-b-lg rounded-lg border border-color-iron">
      <!-- Foto de capa -->
      <div v-if="professional.cover_image == null" 
       @click="isLoadingImage ? '' : showModal('create','cover photo',{},'cover')"
       style="background-image: url('/img/default-cover-photo.png')"
       :class="{'cursor-pointer': !isLoadingImage}" 
      class="w-full h-52 relative profissional-cover-photo">
        <i @click="isLoadingImage ? '' : showModal('create','cover photo',{},'cover')" class="pi pi-camera rounded-full p-2 bg-slate-900 text-white text-lg cursor-pointer absolute bottom-3 right-4"></i>
        <!-- Motion loader box -->
        <span :class="isLoadingImage ? 'block':'hidden'"
        class="w-full h-full flex justify-center items-center" style="background-color: rgba(0,4,0, 0.4);">
          <MotionLoaderComponent class="w-28"  />
        </span>
      </div>
      <div v-else :style="{
        backgroundImage: `url(${professional.cover_image})`,
      }" 
       @click="isLoadingImage ? '' : showModal('update','cover photo',{image: professional.cover_image},'cover')" 
       :class="{'cursor-pointer': !isLoadingImage}" 
       class="w-full h-52 relative profissional-cover-photo">
        <i @click="isLoadingImage ? '' : showModal('update','cover photo',{image: professional.cover_image},'cover')" class="pi pi-camera rounded-full p-2 bg-slate-900 text-white text-lg cursor-pointer absolute bottom-3 right-4"></i>
        <!-- Motion loader box -->
        <span :class="isLoadingImage ? 'block':'hidden'"
        class="w-full h-full flex justify-center items-center" style="background-color: rgba(0,4,0, 0.4);">
          <MotionLoaderComponent class="w-28"  />
        </span>
      </div>

      <!-- Foto de perfil -->
      <div :style="{ backgroundImage: `url(${professional.profile_image})` }" 
        class="w-36 h-36 ml-6 md:ml-20 -mt-16 rounded-full relative bg-oxford-blue border-2 border-white overflow-hidden profissional-profile-photo">
        <i v-if="professional.profile_image == null" 
        @click="isLoadingImageProfile ? '' : showModal('create','profile photo',{},'profile')" class="pi pi-camera rounded-full p-1.5 bg-slate-900 border border-white text-white text-lg cursor-pointer absolute bottom-5 right-4"></i>
        <i v-else @click="isLoadingImageProfile ? '' : showModal('update','profile photo',{image: professional.profile_image},'profile')" class="pi pi-camera rounded-full p-1.5 bg-slate-900 border border-white text-white text-lg cursor-pointer absolute bottom-5 right-4"></i>
         <!-- Motion loader box -->
        <span :class="isLoadingImageProfile ? 'block':'hidden'"
          class="w-full h-full flex justify-center items-center" style="background-color: rgba(0,4,0, 0.4);">
          <MotionLoaderComponent class="w-24"  />
        </span>
      </div>

      <Skeleton v-if="isLoading && professional" height="1.5rem" class="mt-3"></Skeleton>
      <div v-else-if="!isLoading && Object.keys(professional).length > 0" class="w-full px-6 flex flex-col justify-center md:justify-normal md:pl-20 pt-3 relative">
        <span class="flex items-center mb-2">
          <h1 class="text-2xl font-semibold capitalize text-oxford-blue">
            {{ professional.name_complete }} 
          </h1>
          <i class="pi pi-verified hidden ml-2 font-medium text-sea-serpent" style="font-size: 1.3rem"></i>
        </span>

        <h3 class="text-lg font-normal text-gray-700">
          {{ professional.title ? professional.title : translate('your title', 'ucfirst') }}  
        </h3>
        <span v-if="Object.keys(personLocation).length > 0" class="flex items-center pt-3">
          <i class="pi pi-building mr-1" style="font-size: 1.2em"></i>
          <h4 class="capitalize font-semibold">{{ personLocation.country }}{{', ' +personLocation.city}}</h4> 
        </span>
        <i @click="showModal('update','professional data',professional,'title')" class="pi pi-pencil cursor-pointer absolute -top-2 right-5 text-lg"></i>
      </div>
    </div>

    <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
      <template #title>
        {{ displayModalTitle }}
      </template>
      <template #content>
        <component :is="
          selectForm == 'title' 
          ? ProfessionalTitleForm
          : ProfessionalProfilePhotoUploadForm" 
          :data-to-update="dataToUpdate"
          @data-updated="professionalDataUpdated" @close-modal="closeModalDialog" />
      </template>
    </ModalDialogComponent>

  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalProfilePhotoUploadForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalProfilePhotoUploadForm.vue";
import ProfessionalTitleForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalTitleForm.vue";
import MotionLoaderComponent from "@/components/Svg/MotionLoaderComponent.vue";


const props = defineProps({
  professionalData: {
    type: Object,
    required: true,
    default: () => {}
  }
});


let isLoadingImageProfile = ref(false)
let isLoadingImage = ref(false)
let isLoading = ref(true)
let professional = ref({})
let dataToUpdate = ref({})
let visible = ref(false)
let selectForm = ref('')
let personLocation = ref({})
let fetchNewData = ref({}) // Verify new data to update the DOM 

let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum()


// ############ Criação de Métodos/Funções ############

function showModal(type, title, data = {},chooseForm='') {
  selectForm.value = chooseForm
  toggleCreateUpdateTitle(type, title)
  if (chooseForm == 'title') {
    data.country_id = personLocation.value.country_id
    data.city = personLocation.value.city
  }
  data.type_image = chooseForm // Profile image or cover image
  dataToUpdate.value = data
  visible.value = true
}

function closeModalDialog(event) {
  visible.value = event
}

async function professionalDataUpdated() {
  selectForm.value == 'profile' 
  ? isLoadingImageProfile.value = true
  : isLoadingImage.value = true

  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) {
    fetchNewData.value = response.data.professional; 
  }

  getDataperson()
  isLoadingImageProfile.value= false
  isLoadingImage.value= false
  isLoading.value = false
}

async function getDataperson() { 
  const response = await requestHandler.executeRequest("/api/dataperson",{},"get");
  if (response.success) personLocation.value = response.data;
}

onUpdated(() => {
  if(Object.keys(fetchNewData.value).length > 0){
    professional.value = fetchNewData.value
  } 
  else if (Object.keys(props.professionalData).length > 0) {
    professional.value = props.professionalData 
  }
  isLoading.value = false
})

onMounted(() => {
  getDataperson()
  isLoading.value = true
});
</script>

<style scoped>
.profissional-cover-photo {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.profissional-profile-photo {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.profissional-profile-photo > i {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}
.profissional-profile-photo:hover > i {
  opacity: 1;
  transition: opacity 1s ease-in-out;
}
</style>